
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.374 16.878c.045.3-.067.62-.326.83-.438.39-1.147.39-1.586 0l-4.51-4.01c-.259-.23-.371-.54-.326-.83v-5.12L.238 1.62C-.145 1.19-.055.56.428.22.644.08.879 0 1.127 0h15.748c.247 0 .483.08.697.22.484.34.574.97.191 1.4l-5.388 6.129v9.129zM3.421 2l4.454 5.059v5.52l2.25 1.999V7.049l4.454-5.05H3.421z","fill":"#263238","opacity":".5"}})])
          )
        }
      }
    